var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 47,
  height: 47,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M35 3.126A23.333 23.333 0 1 1 .012 24.09L0 23.333l.012-.756A23.333 23.333 0 0 1 35 3.127Zm-3.017 13.89a2.333 2.333 0 0 0-3.08-.193l-.22.194L21 24.698l-3.017-3.015-.22-.193a2.334 2.334 0 0 0-3.273 3.273l.194.22 4.666 4.666.22.194a2.333 2.333 0 0 0 2.86 0l.22-.194 9.333-9.333.194-.22a2.333 2.333 0 0 0-.194-3.08Z",
  fill: "#fff"
})));
export default SvgCheck;